import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const ApplicationModule = {
  namespaced: true,
  strict: true,
  state: {
    application: null,
    company: null,
    profession: null,
    employee: null,
    companyEmployments: null,
    orders: null,
    distanceEducations: null,
    workplace: null,
    departments: null,
    department: null,
  },
  getters,
  actions,
  mutations
};

export default ApplicationModule;
